import {css} from '../utils.js';

const styles = css`
    .accordion {
        width: 100%;
        left: 0;
        top: 60px;
        display: flex;
        flex-direction: column;
        position: sticky;
        border-top: 1px solid ${({theme}) => theme.card_border.color};
        background-color: ${({theme}) => theme.background_page};
        overflow-y: auto;
    }

    .accordion_with_action {
        max-height: calc(100vh - 130px);
    }

    .accordion_without_action {
        max-height: calc(100vh - 60px);
    }
    
    .action_button_container {
        padding: 16px;
        background-color: #F1F1F1;
        position: sticky;
        bottom: 0px;
        top: calc(100vh - 70px);
        height: 70px;
    }
`;

export default styles;
